import {Box} from "@mui/material";
import {CustomVoucherDetailItem} from "../../../../_fri/components/CustomVoucherDetailItem/CustomVoucherDetailItem";
import {Transaction} from "../../../../store/api/interface/ecommerce";
import {formatDate} from "../../../../_fri/utils/function";
interface IVoucherDetail{
    transaction:Transaction
}
export const VoucherDetail = ({transaction}:IVoucherDetail) => {
    return (
        <Box>
            <CustomVoucherDetailItem title={'Fecha:'} detail={formatDate(transaction.creationDate)}/>
            <CustomVoucherDetailItem title={'No. de compra:'} detail={transaction.reference}/>
            <CustomVoucherDetailItem title={'No. de autorización fri:'} detail={transaction.authorizationNumber||''}/>
            <CustomVoucherDetailItem title={'Total:'} detail={transaction.formattedAmount}/>
            <CustomVoucherDetailItem title={'Resumen de compra:'} detail={transaction?.note||''}/>
        </Box>
    );
};